import type { MetaFunction } from "@remix-run/cloudflare";

import ClientSection from "~/components/landing/client-section";
import CallToActionSection from "~/components/landing/cta-section";
import HeroSection from "~/components/landing/hero-section";
// import PricingSection from "~/components/landing/pricing-section";
import LandingPageLayout from "~/components/layouts/landing-page-layout";
import { SphereMask } from "~/components/ui/sphere-mask";

export const meta: MetaFunction = () => {
  return [
    { title: "Product Radar - Find Your Interest Products Early" },
    { name: "description", content: "Input your products or interest products descriptio, and when it comes to market, Product Radar will find your related products as early as possible." },
  ];
};

export default function Index() {
  return (
    <LandingPageLayout>
      <HeroSection />
      <ClientSection />
      <SphereMask />
      {/* <PricingSection /> */}
      <CallToActionSection />
    </LandingPageLayout>
  );
}
